import type { ApolloCache } from "@apollo/client/cache"

import { exists } from "shared/lib/exists"
import { findChild } from "shared/lib/treeUtils"
import { ProjectChild, ProjectParentTypename } from "shared/types/Project"

import { getProjectChildren } from "./getProjectChildren"
import { sortProjectChildrenAndUpdateIndex } from "./sortProjectChildren"
import { updateProjectChildren } from "./updateProjectChildren"

export function insertProjectChild({
  child,
  position,
  parentID,
  parentType,
  cache
}: {
  child: ProjectChild
  position?: number
  parentID: string
  parentType: ProjectParentTypename
  cache: ApolloCache<object>
}) {
  let children = getProjectChildren(parentID, parentType, cache) || []
  const isExisting = !!findChild(child.id, children)

  if (isExisting) {
    return
  }

  children.splice(exists(position) ? position : children.length, 0, child)
  children = sortProjectChildrenAndUpdateIndex(
    children.map((c, index) => ({ ...c, position: index }))
  )
  updateProjectChildren({
    parentID,
    parentType,
    children,
    cache
  })
}
